
document.addEventListener('DOMContentLoaded', (event) => {
    const sections = document.querySelectorAll('.m-featured-collection-section');
    sections.forEach((section) => {
        initCollections(section);
        section.querySelectorAll('.m-section__content').forEach((content) => {
            const swiperContainer = content.querySelector('.swiper');
            const swiperCollections = new Swiper(swiperContainer, {
            slidesPerView: 5, 
            navigation: {
                nextEl: content.querySelector('.swiper-button-next'),
                prevEl: content.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                1301: {
                slidesPerView: 5, 
                },
                1300: {
                slidesPerView: 4, 
                },
                1000: {
                slidesPerView: 3,
                },
                767: {
                slidesPerView: 2, 
                },
            },
            });
            swiperCollections.init();
            const screenWidth = window.innerWidth;

            if (screenWidth < 767) {
              swiperWrapper.classList.remove('swiper-wrapper');
              swiperWrapper.classList.add('no-swiper-wrapper');
              swiper.destroy(true, true);
            } 
        });
    });

    function initCollections(section) {
        const navigations = section.querySelectorAll('.featured-collections-navigation');
        const collections = section.querySelectorAll('.m-section__content')
        
        navigations.forEach((navigation, index) => {
        navigation.addEventListener('click', () => {
            collections.forEach((collection, i) => {
                collection.classList.remove('open');
                navigations[i].classList.remove('open');
            });
            navigation.classList.add('open')
            collections[index].classList.add('open');
        });
        });
    }
});



